import { SignOutIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { ExitFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Terminal block — the contact leaves the workflow. No outgoing handle. */
export function ExitNode({ data, selected }: NodeProps<ExitFlowNode>) {
  return (
    <NodeShell
      icon={SignOutIcon}
      accent="rose"
      kind="Exit"
      label={data.label}
      description="Contact leaves the workflow"
      selected={selected}
      hasSource={false}
      duplicable={false}
    />
  )
}
